import {useEffect, useRef} from 'react';

const useLockBodyScroll = (isPreventScroll) => {
  const scrollPositionRef = useRef(0);

  useEffect(() => {
    if (isPreventScroll) {
      scrollPositionRef.current = window.scrollY;

      const hasHorizontalScroll =
        document.documentElement.scrollWidth > window.innerWidth;

      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPositionRef.current}px`;
      document.body.style.overflowY = 'scroll';
      document.body.style.width = '100%';
     
      // 가로 스크롤이 존재할때만 스크롤 영역 존재 해당 코드가 없을 시 스크롤 위치가 변경되어 isPreventScroll 무한 변경

      if (hasHorizontalScroll) {
        document.body.style.overflowX = 'scroll';
      } else {
        document.body.style.overflowX = 'hidden';
      }
    }

    return () => {
      if (isPreventScroll) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.overflowY = '';
        document.body.style.overflowX = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollPositionRef.current);
      }
    };
  }, [isPreventScroll]);
};

export default useLockBodyScroll;
